import(/* webpackMode: "eager" */ "/app/node_modules/.bun/next@16.2.6+5644c538f55764c0/node_modules/next/dist/client/app-dir/link.js");
